import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  standalone: false,
    selector: "app-pagination-info",
    templateUrl: "./pagination-info.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./pagination-info.component.scss"],
})
export class PaginationInfoComponent implements OnInit {
    @Input() pageSize: number = 10;
    @Input() currentPage: number = 1;
    @Input() totalItems: number = 0;
    @Input() dataLength: number = 0;
    @Input() itemName: string = "items";
    @Input() isNode: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
